export default __webpack_public_path__ + "static/media/YAS0360.34I-29774_-17877_0.59120ffc.jpg";